window.addEventListener("DOMContentLoaded", function () {


    /**
     *  Scroll menu *
     **/
    function fixedMenu() {
        const navbar = document.getElementById("main-nav");
        const sticky = navbar.offsetHeight / 1.5;
        navbar.classList.toggle("scrolled", window.scrollY >= 250);
    }
    document.addEventListener("scroll", () => {
        requestAnimationFrame(fixedMenu);
    });

    let navbarToggler = document.querySelector(".navbar-toggler");
    if (navbarToggler) {
        const navbar = document.getElementById("main-nav");
        const navbarCollapse = document.querySelector("#main-nav .navbar-collapse");

        navbarToggler.addEventListener("click", function (e) {
                if(!navbar.classList.contains("full")){
                    document.getElementById("main-nav").classList.add("full");
                }
            }
        )

        // Gestion du survol pour fermer le menu
        navbar.addEventListener("mouseleave", function (e) {
            if (navbar.classList.contains("full")) {
                navbar.classList.remove("full");
            }
            if (navbarCollapse.classList.contains("show")) {
                navbarCollapse.classList.remove("show");
            }
        });
    }


    /**
     * Cookies - tarte au citron
     */
    let cookies = document.querySelector(".cookies");
    if (cookies) {
        cookies.addEventListener("click", function (e) {
            e.preventDefault();
            if (tarteaucitron) {
                tarteaucitron.userInterface.openPanel();
            }
        });
    }


    /**
     * Top bouton
     */
    let btn = document.querySelector("#topbut");
    if (btn) {
        window.addEventListener("scroll", () => {
            btn.classList.toggle("visible", window.scrollY > 300);
        });

        btn.addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector("html, body").scrollTop = 0;
        });
    }


    /**
     ** Sliders Programmes (Page Accueil)
     **/
    const sliderProgrammes = document.querySelector('#programmes');
    if (sliderProgrammes) {
        const flktysliderProgrammes = new Flickity(sliderProgrammes, {
            "contain": true,
            "pageDots": false,
            "wrapAround": true,
            "draggable": true,
            "cellAlign": "left",
            "prevNextButtons": true,
            // "autoPlay": true,
            "autoPlay": 3000,
            "pauseAutoPlayOnHover": false,
            // "groupCells": 2
        });
    }

    /**
     * Slider Galerie (Page Détails Programme)
     */
    const sliderGalerie = document.querySelector('#galery');
    if (sliderGalerie) {
        const flktysliderGalery = new Flickity(sliderGalerie, {
            "contain": true,
            "pageDots": false,
            "wrapAround": true,
            "draggable": true,
            "cellAlign": "center",
            "prevNextButtons": true,
            // "autoPlay": true,
            "autoPlay": 3000,
            "pauseAutoPlayOnHover": false
        });
    }


    /**
     * Modal Maquette 3D (Page Détails Programme)
     */
    let myModal = document.getElementById('myModal');
    let closeButton = document.querySelector('.btn-close-modal');
    let maquetteButton = document.getElementById('maquette');
    if (maquetteButton != null) {
        maquetteButton.addEventListener('click', function () {
            myModal.classList.remove('no-visible');
        });
    }
    if (closeButton != null) {
        closeButton.addEventListener('click', function() {
            myModal.classList.add('no-visible');
        });
    }


    /**
     * Formulaire Plaquette
     */
    let toggleFormulaire = document.getElementById('toggleFormulaire');
    let formulairePlaquette = document.getElementById('formulairePlaquette');
    if (toggleFormulaire != null) {
        toggleFormulaire.addEventListener('click', function () {
            formulairePlaquette.classList.toggle('visible');
            toggleFormulaire.classList.toggle('bg-primary');
        });
    }
});
